export default __webpack_public_path__ + "static/manik-khurana-4cd0f61028cb54bdf668b8140fa39fd1.png";